import React, { useState } from 'react';
import { Copy, KeyRound } from 'lucide-react';
import { getSupabaseClient } from '../../lib/supabase';

export const ResidentInviteManager: React.FC = () => {
  const [houseNumber, setHouseNumber] = useState('');
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const issue = async (event: React.FormEvent) => {
    event.preventDefault(); setCode(''); setError('');
    const client = getSupabaseClient();
    if (!client) { setError('ยังไม่ได้เชื่อมต่อ Supabase'); return; }
    setBusy(true);
    try {
      const { data, error: rpcError } = await client.rpc('issue_resident_invite', {
        p_house_number: houseNumber.trim(), p_expires_in_days: 7,
      });
      if (rpcError) throw rpcError;
      setCode(data as string);
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : 'ออกโค้ดเชิญไม่สำเร็จ');
    } finally { setBusy(false); }
  };

  return <section className="rounded-2xl border border-blue-200 bg-white p-5 shadow-sm">
    <div className="mb-4 flex items-center gap-2"><KeyRound className="h-5 w-5 text-blue-700"/><h2 className="font-bold text-slate-900">รหัสเชิญลูกบ้าน</h2></div>
    <p className="mb-4 text-sm text-slate-600">ออกโค้ดเฉพาะบ้าน ใช้ได้ครั้งเดียวและหมดอายุใน 7 วัน มอบรหัสให้ลูกบ้านโดยตรง</p>
    <form onSubmit={issue} className="flex flex-wrap gap-2">
      <input required value={houseNumber} onChange={e => setHouseNumber(e.target.value)} placeholder="เลขที่บ้าน เช่น 251/75" className="min-w-56 flex-1 rounded-lg border border-slate-300 px-3 py-2" />
      <button disabled={busy} className="rounded-lg bg-blue-700 px-4 py-2 font-semibold text-white disabled:opacity-60">{busy ? 'กำลังออกโค้ด…' : 'ออกโค้ดเชิญ'}</button>
    </form>
    {error && <p role="alert" className="mt-3 text-sm text-rose-700">ออกโค้ดไม่สำเร็จ ตรวจสอบว่าบัญชีนี้เป็น Admin และลองใหม่</p>}
    {code && <div className="mt-4 flex flex-wrap items-center gap-3 rounded-lg bg-emerald-50 p-3"><code className="font-mono text-lg font-bold tracking-widest text-emerald-900">{code}</code><button type="button" onClick={() => navigator.clipboard.writeText(code)} className="inline-flex items-center gap-1 rounded-md border border-emerald-300 bg-white px-3 py-1.5 text-sm text-emerald-900"><Copy className="h-4 w-4"/>คัดลอก</button><span className="text-xs text-emerald-800">แสดงครั้งเดียว · อายุ 7 วัน · บ้าน {houseNumber}</span></div>}
  </section>;
};
